import { EPdfPrintRoute } from 'common/enum/pdf.print.enum';
import { getEnumValues } from 'common/utils/enum.utils';

export const isPdfPrintPath = (path: string): boolean =>
  getEnumValues(EPdfPrintRoute).some((route) => path.startsWith(`/${route}`));
